import { MarketBasket } from '@qv-bid/entities';

export class MarketBasketSection {
  constructor(
    public marketBasketLock: boolean,
    public marketBasket: MarketBasket
  ) {}
}
